import { Controller } from "@hotwired/stimulus"
import { Carousel } from "bootstrap"

export default class extends Controller {
  static targets = ["carousel", "quantity", "lightbox", "lightboxBody"]

  connect() {
    this.bsCarousel = new Carousel(this.carouselTarget, { ride: false })
    this.images = Array.from(
      this.carouselTarget.querySelectorAll(".carousel-item img")
    ).map((img) => ({ src: img.src, alt: img.alt }))
    this.currentIndex = 0

    this.carouselTarget.addEventListener("slid.bs.carousel", (e) => {
      this.currentIndex = e.to
      this.syncThumbnails(e.to)
    })

    this.lightboxTarget.addEventListener("click", (e) => {
      if (e.target === this.lightboxTarget) this.closeLightbox()
    })

    this._onKeydown = (e) => {
      if (!this.lightboxTarget.classList.contains("open")) return
      if (e.key === "Escape") this.closeLightbox()
      if (this.lightboxTarget.dataset.mode === "single") {
        if (e.key === "ArrowLeft") this.prevImage()
        if (e.key === "ArrowRight") this.nextImage()
      }
    }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    this.bsCarousel?.dispose()
    document.removeEventListener("keydown", this._onKeydown)
  }

  goToSlide(e) {
    const index = parseInt(e.currentTarget.dataset.slideIndex, 10)
    this.bsCarousel.to(index)
    this.currentIndex = index
    this.syncThumbnails(index)
  }

  syncThumbnails(activeIndex) {
    this.element.querySelectorAll(".item-view__thumb[data-slide-index]").forEach((thumb) => {
      thumb.classList.toggle("active", parseInt(thumb.dataset.slideIndex, 10) === activeIndex)
    })
  }

  openGallery() {
    this.lightboxTarget.dataset.mode = "grid"
    this.renderGrid()
    this.lightboxTarget.classList.add("open")
    document.body.style.overflow = "hidden"
  }

  openImage(e) {
    this.currentIndex = parseInt(e.currentTarget.dataset.lightboxIndex, 10)
    this.lightboxTarget.dataset.mode = "single"
    this.renderSingle()
  }

  closeLightbox() {
    if (this.lightboxTarget.dataset.mode === "single") {
      this.lightboxTarget.dataset.mode = "grid"
      this.renderGrid()
    } else {
      this.lightboxTarget.classList.remove("open")
      document.body.style.overflow = ""
    }
  }

  prevImage() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
    this.renderSingle()
  }

  nextImage() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length
    this.renderSingle()
  }

  renderGrid() {
    this.lightboxTarget.querySelector(".item-view__lightbox-body").innerHTML = `
      <div class="item-view__lightbox-grid">
        ${this.images.map((img, i) => `
          <div class="item-view__lightbox-thumb"
               data-action="click->item-view#openImage"
               data-lightbox-index="${i}">
            <img src="${img.src}" alt="${img.alt}" />
          </div>
        `).join("")}
      </div>
    `
  }

  renderSingle() {
    const img = this.images[this.currentIndex]
    this.lightboxTarget.querySelector(".item-view__lightbox-body").innerHTML = `
      <div class="item-view__lightbox-single">
        <button class="item-view__lightbox-nav item-view__lightbox-nav--prev"
                data-action="click->item-view#prevImage">
          <i class="fas fa-chevron-left"></i>
        </button>
        <div class="item-view__lightbox-img-wrap">
          <img src="${img.src}" alt="${img.alt}" />
        </div>
        <button class="item-view__lightbox-nav item-view__lightbox-nav--next"
                data-action="click->item-view#nextImage">
          <i class="fas fa-chevron-right"></i>
        </button>
        <div class="item-view__lightbox-counter">
          ${this.currentIndex + 1} / ${this.images.length}
        </div>
      </div>
    `
  }

  // increment() {
  //   this.quantityTarget.value = parseInt(this.quantityTarget.value || 0) + 1
  // }

  // decrement() {
  //   const current = parseInt(this.quantityTarget.value || 1)
  //   if (current > 1) this.quantityTarget.value = current - 1
  // }

}